/**
 * SEO Tweaks
 * Handles various SEO-related optimizations and redirects
 */

(() => {
  "use strict";

  /**
   * Add noindex meta tag for URLs with query parameters
   * Prevents duplicate content issues from parameterized URLs
   * Example: https://www.beofit.com/blogs/news?page=2 gets noindex
   */
  const addNoindexForParameters = () => {
    if (window.location.search) {
      const metaRobots = document.createElement("meta");
      metaRobots.name = "robots";
      metaRobots.content = "noindex, follow";
      document.head.appendChild(metaRobots);
    }
  };

  /**
   * Normalize URL pathname and redirect if needed
   * Handles:
   * 1. Multiple consecutive slashes: https://www.beofit.com////// -> https://www.beofit.com/
   * 2. Case-sensitive URLs: https://www.beofit.com/collections/ORGanic-protein-shake -> https://www.beofit.com/collections/organic-protein-shake
   */
  const normalizeUrl = () => {
    const path = window.location.pathname;
    let cleanPath = path;

    // Remove multiple consecutive slashes
    cleanPath = cleanPath.replace(/\/+/g, "/");

    // Convert to lowercase
    cleanPath = cleanPath.toLowerCase();

    // Only redirect if the path has changed
    if (path !== cleanPath) {
      const cleanUrl = `${window.location.protocol}//${window.location.host}${cleanPath}${window.location.search}${window.location.hash}`;

      // Use replace() to avoid creating browser history entry (301-like behavior)
      window.location.replace(cleanUrl);
    }
  };

  /**
   * Remove redundant ?page=1 parameter
   * Handles duplicate content issue where page=1 is the same as no page parameter
   * Example: https://www.beofit.com/blogs/news?page=1 -> https://www.beofit.com/blogs/news
   */
  const removePageOneParameter = () => {
    const urlParams = new URLSearchParams(window.location.search);

    // Check if page=1 exists
    if (urlParams.get("page") === "1") {
      // Remove the page parameter
      urlParams.delete("page");

      // Build the clean URL
      const newSearch = urlParams.toString();
      const cleanUrl = `${window.location.protocol}//${window.location.host}${
        window.location.pathname
      }${newSearch ? "?" + newSearch : ""}${window.location.hash}`;

      // Use replace() to avoid creating browser history entry (301-like behavior)
      window.location.replace(cleanUrl);
    }
  };

  /**
   * Remove /index.html and /index.htm from URLs
   * Handles duplicate content issue
   * Example: https://www.beofit.com/index.html -> https://www.beofit.com/
   */
  const removeIndexFiles = () => {
    const path = window.location.pathname;

    // Check if URL ends with /index.html or /index.htm
    if (path.endsWith("/index.html") || path.endsWith("/index.htm")) {
      // Remove the index file from the path
      const cleanPath = path.replace(/\/index\.html?$/, "/");
      const cleanUrl = `${window.location.protocol}//${window.location.host}${cleanPath}${window.location.search}${window.location.hash}`;

      // Use replace() to avoid creating browser history entry (301-like behavior)
      window.location.replace(cleanUrl);
    }
  };

  // Initialize on page load
  addNoindexForParameters();
  normalizeUrl();
  removePageOneParameter();
  removeIndexFiles();
})();
